import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const HeaderLink = styled(NavLink)<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;

  ${({ $disabled }) =>
    $disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}
`;
